import React from 'react';

import { HubManager } from './HubManager';
import type { ITariffCardReactModel } from '../types';
import { useESimModalState } from './useESimModalState';

export function withHubManager(WrappedComponent: React.ComponentType<ITariffCardReactModel>) {
  return (props: ITariffCardReactModel) => (
    <>
      <WrappedComponent {...props} />
      <HubManager {...props} />
    </>
  );
}

export function withHubManagerInjection(
  WrappedComponent: React.ComponentType<ITariffCardReactModel & { setESimOpenModal: () => void }>,
) {
  return (props: ITariffCardReactModel) => {
    const [_, toogleESimModal] = useESimModalState();

    return (
      <>
        <WrappedComponent {...props} setESimOpenModal={toogleESimModal} />
        <HubManager {...props} />
      </>
    );
  };
}
